import React, {Component} from "react";
import Button from "@material-ui/core/Button";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Addlease from '../../../../Forms/Addlease';
import { getLeases, getLeaseTypes, searchLease, deleteLease } from '../../../../appRedux/actions/leaseAction';
import { propertyTypes } from '../../../../appRedux/actions/loansAction';
import { vendorTypes,Vendors } from '../../../../appRedux/actions/vendorAction';
import SearchBox from '../../../../components/SearchBox';
import CircularProgress from "../../../../components/CircularProgress";
import moment from 'moment';
import _ from 'lodash';
import "react-toastify/dist/ReactToastify.css";
import {Table, Pagination  } from 'antd';
import { Resizable } from 'react-resizable';
import "../../styles.css";
import "./LeasesPage.css";

const ResizeableTitle = props => {
  const { onResize, width, ...restProps } = props;

  if (!width) {
    return <th {...restProps} />;
  }

  return (
    <Resizable width={width} height={0} onResize={onResize}>
      <th {...restProps} />
    </Resizable>

  );
};

class LeasesPage extends Component {
  constructor(props) {
    super(props);

    let column = [{
      title: 'Vendor Name',
      dataIndex: 'vendorName',
      className:'table-heading',
      sorter:  true,
      width:150
  },{
        title: 'Finance Company',
        dataIndex: 'financeCompany',
        className:'table-heading',
        sorter:  true,
        width:180
    },{
      title: 'Property Type',
      dataIndex: 'propertyType',
      className:'table-heading',
      sorter:  true,
      width:150
  },
    {
        title: 'Monthly Payments',
        dataIndex: 'monthlyPayments',
        className:'table-heading',
        sorter:  true,
        render: text => <span>
          $ {parseFloat(text).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
        </span>,
        width:150
    },
    {
        title: 'Term (Months)',
        dataIndex: 'terms',
        className:'table-heading',
        sorter:  true,
        width:180
    },
    {
        title: 'Last Payment',
        dataIndex: 'lastPaymentDate',
        className:'table-heading',
        render: text => <span title={moment(text).format("LL")}>
          {moment(text).format("L") }
        </span>,
        sorter:  true,        
        width:100
    },{
      title: 'Automatic Renewal',
      dataIndex: 'automaticRenewal',
      className:'table-heading',
      sorter:  true,
      width:120,
      render: text => <span title={moment(text).format("LL")}>
        {text ? "Yes" : "No"}
      </span>,
  },
    {
        title: 'Comments',
        dataIndex: 'comments',
        className:'table-heading',
        sorter:  true,
        width:180,
    },
    {
        title: 'Alert Date',
        dataIndex: 'alertDate',
        className:'table-heading',
        render: text => <span title={moment(text).format("LL")}>
          {moment(text).format("L") }
        </span>,
        sorter:  true,
        width:100
    },
    {
        title: 'Alert Comments',
        dataIndex: 'alertComments',
        className:'table-heading',
        sorter:  true,
        width:120
    },
    
    {
        title: 'Lease Review Complete',
        dataIndex: 'leaseReviewComplete',
        className:'table-heading',
        sorter:  true,
        render: text => <span title={moment(text).format("LL")}>
          {text ? "Yes" : "No"}
        </span>,
        width:90
    },
    
    {
        title: 'Lease Review Date',
        dataIndex: 'leaseReviewDate',
        className:'table-heading',
        sorter:  true,
        width:140,
        render: text => <span title={moment(text).format("LL")}>
          {moment(text).format("L") }
        </span>,
    }

    ];

    this.state = {
      pageSize:50,
			currentPage:1,
			totalRowsInTable:0,
			fieldName:'leaseId',
			sortFormat:'A',
      searchText:'',
      search:false,
      columns: column,
      isAdd: false,
      edit:false,
      leases:[],
	  vendors:[],
      leaseTypes:[],
      properties:[],
      vendorType:[],
      loading:true,
      isUservisibile: false,
      selectedLease:'',
      companyId:'',
      selectedItemKey:0
    }
  };


  componentDidMount(){

    this.listData();
    this.props.getLeaseTypes();
    this.props.propertyTypes();
    this.props.vendorTypes();
	let user = JSON.parse(localStorage.getItem('userData'));
	this.props.Vendors(user.companyId);
  }
  listData()
  {
    let user = JSON.parse(localStorage.getItem('userData'));
    const CompanyId = user.companyId;
    this.setState({companyId:user.companyId})
    this.props.getLeases(CompanyId,this.state.searchText,this.state.currentPage,this.state.pageSize,this.state.fieldName,this.state.sortFormat);
  }
  componentWillReceiveProps(nextProps) {    

     if(nextProps.lease!==undefined && nextProps.lease !== this.props.lease ){
       if(nextProps.lease.length>0)
          this.state.totalRowsInTable = nextProps.lease[0].totalrows;
          this.setState({
           leases:nextProps.lease,
           loading:false,
         });
      }
      if(nextProps.vendorType!==undefined && nextProps.vendorType !== this.props.vendorType  ){
         this.setState({
           vendorType:nextProps.vendorType
         });
      }
	  if(nextProps.vendors!==undefined && nextProps.vendors !== this.props.vendors  ){
         this.setState({
           vendors:nextProps.vendors
         });
      }
      if(nextProps.leaseTypes!==undefined && nextProps.leaseTypes !== this.props.leaseTypes ){
         this.setState({
           leaseTypes:nextProps.leaseTypes,
       });
       }
       if(nextProps.properties !==undefined && nextProps.properties !== this.props.properties ){        
         this.setState({
         properties:nextProps.properties
       });
     }
     if(nextProps.reload==true)
       this.listData();

  }





  handleChange = (text) => {
    var self=this;
    if(text) {

      self.state.searchText = text;


      } else {
        self.state.searchText = '';

      }
      self.state.currentPage =1;
      this.setState({search:true});

    clearTimeout(self.state.timeout);

    // Make a new timeout set to go off in 800ms
    self.state.timeout = setTimeout(function () {
      self.listData();

    }, 500);

    }

  handleDelete = (id) =>  {
      this.props.deleteLease(id);
       this.setState({
      edit:false,
    });
  }

  handleAddModal = () => {

    this.setState({
		selectedItem:false,
      isAdd: true,
      edit:false,
    });
  }

  handleEditModal= (record) =>{    
      var id=record.key
      var data=this.state.leases;
      if(id!=0)
       {
          const selectedLease = _.find(data, {leaseID:id});
          this.setState({
              selectedLease:_.cloneDeep(selectedLease),
              edit:true,
			  isAdd:false
          });
      }
  }

  handleAddCancel = () => {
    this.setState({ isAdd: false,edit:false});
  }

  handleTableChange = (pagination, filters, sorter) => {
    if(sorter.order)
    {
      this.state.fieldName = sorter.field;
      if(sorter.order =="ascend")
        this.state.sortFormat = "A";
      else
        this.state.sortFormat = "D";
    }
    else
    {
      this.state.fieldName = "leaseId";
      this.state.sortFormat = "A";
    }
    this.listData();
  }

  onShowSizeChange(current, pageSize) {
		this.state.currentPage = current;
		this.state.pageSize = pageSize;
		this.listData();	  
	}
  handleResize = index => (e, { size }) => {
      this.setState(({ columns }) => {
        const nextColumns = [...columns];
        nextColumns[index] = {
          ...nextColumns[index],
          width: size.width,
        };
        return { columns: nextColumns };
      });
    };

  render() {
    const { searchText ,search, selectedLease, properties, leaseTypes, vendorType,vendors} = this.state;
    let { leases } = this.state;
    const columns = this.state.columns.map((col, index) => ({
        ...col,
        onHeaderCell: column => ({
          width: column.width,
          onResize: this.handleResize(index),
        }),
      }));
      const components = {
        header: {
          cell: ResizeableTitle,
        },
      };
    let filteredData = (Array.isArray(leases) ? leases : []).map((d,index)=>({
        key:d.leaseID,
        ...d
    }))
    return (
      <div className="leases-page">
        <Addlease
          propertyTypes={properties}
          leaseTypes={leaseTypes}
          vendorTypes={vendorType}
		  vendors={vendors}
          companyID={this.state.companyId}
          handleSave={this.handleAddCancel}
          visible={!!(this.state.isAdd || this.state.edit)}
		  isEdit={this.state.edit}
          handleCancel={this.handleAddCancel}
		  selectedItem={selectedLease}
		  handleDelete={this.handleDelete}
        />

         {this.state.loading
              ?
               <div className="leases-page-loader">
               <CircularProgress/>
               </div>
              :
              <React.Fragment>
             <div className="leases-page-header">
            <h2 className="leases-page-title">Leases</h2>
            <div className="leases-page-header-actions">
            <SearchBox
               styleName="d-none d-lg-block"
               placeholder="Search..."
               value={searchText}
               onChange= { (e) => {  this.handleChange(e.target.value) }}
               style={{ background: '#eeeeeeb8'}}
             />
            <Button variant="contained" color="primary" onClick={this.handleAddModal}>
                 Add Lease
            </Button>
            </div>
          </div>
              <div className="leases-page-card">
              <div className="leases-page-table-wrap">
              <Table
                  className="table-layout"
                  columns={columns}
                  components={components}
                  dataSource={filteredData}
                  rowClassName={ (record) =>  this.state.selectedItemKey == record.key  ? 'data-row selected' : 'data-row'  }
                  bordered={true}
                  size={"small"}
                  onRow={(record, index) => ({
                    onClick: () => this.handleEditModal(record),
                    onDoubleClick: () => this.handleEditModal(record),
                  })}
                  onChange={this.handleTableChange}
                  loading={this.state.loading}
                  pagination={false}
                  />
              </div>
                  <div className="leases-page-pagination">
                  <Pagination
                  pageSizeOptions={['10','25','50','100']}
                  pageSize={this.state.pageSize}
                  showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                  showSizeChanger onChange={(a,b)=>this.onShowSizeChange(a,b)} onShowSizeChange={(a,b)=>this.onShowSizeChange(a,b)} defaultCurrent={1} total={this.state.totalRowsInTable} />
                  </div>
              </div>
              </React.Fragment>
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    lease: state.lease.leases,
    leaseTypes:state.lease.leaseTypes,
    reload: state.lease.reload,
    properties:state.loans.propertyTypes,
    vendorType:state.vendors.vendorTypes,
	vendors:state.vendors.vendors
  }
}

const mapDispatchToProps=(dispatch)=>{
    return bindActionCreators({
      getLeaseTypes,
      propertyTypes,
      vendorTypes,
	  Vendors,
      deleteLease,
      getLeases,
      searchLease
    },dispatch)
}


export default connect(mapStateToProps, mapDispatchToProps)(LeasesPage);
